<template>
  <div id="app">
    <template v-if="isLoad">
      <!--  class="w_100" -->
      <!-- <Header v-if="!isSignPage" /> -->
      <Search :style="{background: searchMenuBgColor}" v-if="!isSignPage" />
      <Menu :defaultActiveIndex="activeIndex" style="background: #00B58D" ref="menu" v-if="!isSignPage" />
      <template>
        <div class="main" :style="{background: mainBgColor}" v-if="!isSignPage">
          <BreadCrumb />
          <router-view />
        </div>
        <div v-else>
          <router-view />
        </div>
      </template>
      <Bottom v-if="!isSignPage" />
      <!-- <DownApp class="down_app" v-if="isShowDownApp"></DownApp> -->
    </template>

  </div>
</template>

<script>
// import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
// import DownApp from '@/components/down-app/down-app.vue';
import BreadCrumb from '@/components/bread-crumb/bread-crumb.vue';
import { changeSkin } from '@/utils/common.js';
import { routerArr } from '@/utils/default-data.js';
import { getComParams } from '@/utils/comConfig.js';
import Service from '@/service/index.js';
import AreaCodeHolder from '@/common/areaCodeHolder.js';
export default {
  components: {
    // Header,
    Search,
    Menu,
    Bottom,
    BreadCrumb
  },
  data () {
    return {
      isLoad: false, // 是否获取完毕areacode
      isShowDownApp: true,
      screenHeight: '',
      activeIndex: Date.now(),
      searchMenuBgColor: '#F7F7F7',
      mainBgColor: '#FFFFFF',
      isSignPage: false
    };
  },
  watch: {
    $route (newRoute, oldRoute) {
      this.setDefaultActiveIndex();
      this.setSearchMenuBgColor();
      this.setMainBgColor();
      this.showDownApp(newRoute.path, oldRoute.path);
    }
  },
  async created () {
    this.isLoad = false;
    let hostList = window.location.host.split('.');
    let name = hostList[0];
    if (hostList[0] === 'www') {
      name = hostList[1];
    }
    // name = 'liujiangqu';
    // name = 'dahuayaozuzizhixian';
    if (name.includes('localhost') || name.includes('gxcqjyzx')) {
      AreaCodeHolder.getInstance().areaCode = '45';
      AreaCodeHolder.getInstance().level = 1;
      AreaCodeHolder.getInstance().areaName = '广西';
      this.isLoad = true;
    } else {
      const res = await Service.getAreaInfoByName(name);
      if (res.code === '0') {
        AreaCodeHolder.getInstance().areaCode = res.data.areaCode;
        AreaCodeHolder.getInstance().level = res.data.level;
        AreaCodeHolder.getInstance().areaName = res.data.areaName;
        this.isLoad = true;
      }
    }
    getComParams();
    this.changeSkin();
    this.setDefaultActiveIndex();
    this.setSearchMenuBgColor();
    this.setMainBgColor();
    if (this.$route.name && this.$route.name.indexOf('h5Sign') !== -1) {
      this.isSignPage = true;
    }
    this.getTenantAreaInfo();
  },
  mounted () {
    this.showDownApp();
    this.screenHeight = document.body.clientHeight;
    const downApp = document.querySelector('.down_app');
    if (downApp) {
      downApp.style.top = this.screenHeight - 130 + 'px';
      window.onresize = () => {
        return (() => {
          this.screenHeight = document.body.clientHeight;
          downApp.style.top = this.screenHeight - 130 + 'px';
        })();
      };
      window.onscroll = () => {
        return (() => {
          var sl = -Math.max(document.body.scrollLeft, document.documentElement.scrollLeft);
          downApp.style.left = sl + 'px';
        })();
      };
    }
  },
  methods: {
    // 换肤
    changeSkin,
    // 是否展示二维码下载入口
    showDownApp (newPath, oldPath) {
      const isHomePath = this.$route.path === '/' || this.$route.path === '/index';
      if (!oldPath && !newPath && isHomePath) {
        this.isShowDownApp = true;
      } else if (isHomePath && oldPath === '/' && newPath === '/index') {
        this.isShowDownApp = true;
      } else {
        this.isShowDownApp = false;
      }

    },
    // 动态设置menu组件默认展示的下标
    setDefaultActiveIndex () {
      const route = this.$route;
      const arr = ['register', 'signin', 'publish-project', 'person-center', 'publish-purchase']; // menu默认为都不选中的路由数组
      if (arr.find(item => {
        return route.path.indexOf(item) !== -1;
      })) {
        this.activeIndex = Date.now();
      } else {
        this.$refs.menu && this.$refs.menu.changeActiveIndex();
      }
    },
    // 动态设置搜索和菜单栏背景颜色
    setSearchMenuBgColor () {
      const route = this.$route;
      if (route.path.indexOf('person-center') !== -1) {
        if (routerArr.find(item => {
          return route.path.indexOf(item) !== -1;
        })) {
          this.searchMenuBgColor = '#F7F7F7';
        } else {
          this.searchMenuBgColor = '#FFFFFF';
        }
      } else {
        this.searchMenuBgColor = '#F7F7F7';
      }
    },
    // 动态设置主体部分背景颜色
    setMainBgColor () {
      const route = this.$route;
      if (route.path.indexOf('person-center') !== -1) {
        if (routerArr.find(item => {
          return route.path.indexOf(item) !== -1;
        })) {
          this.mainBgColor = '#FFFFFF';
        } else {
          this.mainBgColor = '#F7F7F7';
        }
      } else {
        this.mainBgColor = '#FFFFFF';
      }
    },
    getTenantAreaInfo () {
      Service.getTenantAreaInfo().then(({ code, data }) => {
        if (code === '0') {
          console.log('data :>> ', data);
        }
      });
    }

  }
};
</script>

<style lang='scss' scoped>
.down_app {
  position: fixed;
  width: 100%;
  min-width: 1200px;
  height: 130px;
  display: flex;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  z-index: 999;
  left: 0;
}
.left_img {
  position: absolute;
  left: -21%;
  width: 30%;
  top: 36px;
  height: auto;
  z-index: 9;
}
.right_img {
  position: absolute;
  right: -21%;
  width: 30%;
  height: auto;
  z-index: 9;
  top: 36px;
}
</style>
